import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import { selectCustomer } from "../../redux/actions";

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    selectCustomer: (customer) => {
      dispatch(selectCustomer(customer));
    },
  };
};

export class RouteRedirector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: undefined,
      call: undefined,
      changeToRegister: undefined,
    };
  }

  componentWillMount() {
    let call = this.props.match.params.call;
    if (call != undefined) {
      this.setState({ call: call });
      console.log(call);
      window.server.emit("get_customer", call, (data) => {
        if (data.code == 200) {
          console.log("200");
          let us = JSON.parse(data.response);
          this.props.selectCustomer(us);
          this.setState({ user: us });
          this.setState({ changeToRegister: false });
        }
        if (data.code == 404) {
          console.log("404");
          this.setState({ changeToRegister: true });
        }
      });
    }
  }

  render() {
    if (this.state.user && this.state.changeToRegister === false) {
      return <Redirect to={"/info"} />;
    }
    if (this.state.user == undefined && this.state.changeToRegister === true) {
      return <Redirect to={"/register" + "/" + this.state.call} />;
    }
    return (
      <div>
        <h2>لطفا صبر کنید...</h2>
      </div>
    );
  }
}

const RouteRedirectorConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(RouteRedirector);

export default RouteRedirectorConnect;
